
// // export default DispatchDetails;

// import React, { useState, useEffect } from 'react';
// import { useSearchParams } from 'react-router-dom';
// import styles from './DispatchDetails.module.css';
// import DispatchHeader from './components/DispatchHeader';
// import DispatchTable from './components/DispatchTable';
// import { dispatchApi } from '../../../api/dispatch/dispatchApi';

// const DispatchDetails = () => {
//   const [searchParams] = useSearchParams();
//   const docEntry = searchParams.get('docEntry');
//   const docNum = searchParams.get('docNum');
//   const refNo = searchParams.get('refNo');

//   const [headerData, setHeaderData] = useState(null);
//   const [lineItems, setLineItems] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [isPdfAvailable, setIsPdfAvailable] = useState(false);
//   const [isDownloading, setIsDownloading] = useState(false);

//   useEffect(() => {
//     if (!docEntry || !docNum) {
//       setError('Required parameters (docEntry, docNum) are missing from the URL.');
//       setLoading(false);
//       return;
//     }
//     fetchDispatchDetails();
//   }, [docEntry, docNum, refNo]);

//   const fetchDispatchDetails = async () => {
//     try {
//       setLoading(true);
//       setError(null);

//       console.log('🔍 Fetching dispatch details...', { docEntry, docNum, refNo });

//       const data = await dispatchApi.getDispatchDetails(docEntry, docNum, refNo);
//       console.log('✅ Dispatch data received:', data);

//       const header = {
//         invoiceNo: data.invoiceNo,
//         invoiceDate: data.invoiceDate,
//         customerPoNo: data.customerPoNo,
//         carrierName: data.carrierName,
//         trackingNumber: data.trackingNumber,
//         trackingUpdatedDate: data.trackingUpdatedDate,
//         deliveryDate: data.deliveryDate,
//       };

//       setHeaderData(header);
//       setLineItems(data.lineItems || []);

//       // Check PDF availability after fetching header
//       console.log('🔍 Checking PDF availability for:', data.invoiceNo);
//       const pdfCheck = await dispatchApi.checkPdf(data.invoiceNo);
//       console.log('📄 PDF available:', pdfCheck.exists);
//       setIsPdfAvailable(pdfCheck.exists);

//     } catch (err) {
//       console.error('❌ Error fetching dispatch details:', err);
//       setError(err.message || 'Failed to load dispatch details');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleDownloadInvoice = async () => {
//     try {
//       setIsDownloading(true);
//       await dispatchApi.downloadPdf(headerData.invoiceNo, headerData.invoiceNo);
//     } catch (err) {
//       alert('Failed to download invoice. Please try again.');
//     } finally {
//       setIsDownloading(false);
//     }
//   };

//   if (loading) {
//     return (
//       <div className={styles.loadingContainer}>
//         <div className={styles.spinner} />
//         <p>Loading dispatch details...</p>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className={styles.errorContainer}>
//         <div className={styles.errorIcon}>⚠️</div>
//         <h2>Error</h2>
//         <p>{error}</p>
//       </div>
//     );
//   }

//   return (
//     <div className={styles.page}>
//       <DispatchHeader
//         headerData={headerData}
//         isPdfAvailable={isPdfAvailable}
//         isDownloading={isDownloading}
//         onDownloadInvoice={handleDownloadInvoice}
//       />
//       <DispatchTable lineItems={lineItems} invoiceNo={headerData?.invoiceNo} />
//     </div>
//   );
// };

// export default DispatchDetails;

import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import styles from './DispatchDetails.module.css';
import DispatchHeader from './components/DispatchHeader';
import DispatchTable from './components/DispatchTable';
import { dispatchApi } from '../../../api/dispatch/dispatchApi';

const DispatchDetails = () => {
  const [searchParams] = useSearchParams();
  const docEntry = searchParams.get('docEntry');
  const docNum = searchParams.get('docNum');
  const refNo = searchParams.get('refNo');

  const [headerData, setHeaderData] = useState(null);
  const [lineItems, setLineItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isPdfAvailable, setIsPdfAvailable] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    if (!docEntry || !docNum) {
      setError('Required parameters (docEntry, docNum) are missing from the URL.');
      setLoading(false);
      return;
    }
    fetchDispatchDetails();
  }, [docEntry, docNum, refNo]);

  const fetchDispatchDetails = async () => {
    try {
      setLoading(true);
      setError(null);

      const data = await dispatchApi.getDispatchDetails(docEntry, docNum, refNo);

      setHeaderData({
        invoiceNo: data.invoiceNo,
        invoiceDate: data.invoiceDate,
        customerPoNo: data.customerPoNo,
        carrierName: data.carrierName,
        trackingNumber: data.trackingNumber,
        trackingUpdatedDate: data.trackingUpdatedDate,
        deliveryDate: data.deliveryDate,
      });

      // lineItems already have coaSource, vendorBatchNum, localCoaFilename, energyCoaUrl
      setLineItems(data.lineItems || []);

      const pdfCheck = await dispatchApi.checkPdf(data.invoiceNo);
      setIsPdfAvailable(pdfCheck.exists);

    } catch (err) {
      setError(err.message || 'Failed to load dispatch details');
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadInvoice = async () => {
    try {
      setIsDownloading(true);
      await dispatchApi.downloadPdf(headerData.invoiceNo, headerData.invoiceNo);
    } catch {
      alert('Failed to download invoice. Please try again.');
    } finally {
      setIsDownloading(false);
    }
  };

  // Add this derived value (after lineItems state):
const isCOAAvailable = lineItems.some(
  item => item.coaSource && item.coaSource !== 'NONE'
);

// Add this handler:
const handleDownloadAllCoa = async () => {
  const coaItems = lineItems.filter(
    item => item.coaSource && item.coaSource !== 'NONE'
  );

  for (let i = 0; i < coaItems.length; i++) {
    try {
      await handleDownloadCoa(coaItems[i]);
      // Small delay between downloads to avoid browser blocking
      if (i < coaItems.length - 1) {
        await new Promise(resolve => setTimeout(resolve, 400));
      }
    } catch {
      console.error(`Failed to download COA for ${coaItems[i].itemNo}`);
    }
  }
};

  // NEW: COA download handler
  const handleDownloadCoa = async (item) => {
    try {
      if (item.coaSource === 'LOCAL') {
        await dispatchApi.downloadDensityCoa(item.itemNo, item.vendorBatchNum);
      } else if (item.coaSource === 'ENERGY') {
        await dispatchApi.downloadEnergyCoa(item.itemNo, item.vendorBatchNum);
      }
    } catch {
      alert('Failed to download COA. Please try again.');
    }
  };

  if (loading) {
    return (
      <div className={styles.loadingContainer}>
        <div className={styles.spinner} />
        <p>Loading dispatch details...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.errorContainer}>
        <div className={styles.errorIcon}>⚠️</div>
        <h2>Error</h2>
        <p>{error}</p>
      </div>
    );
  }

  return (
    <div className={styles.page}>
      <DispatchHeader
        headerData={headerData}
        isPdfAvailable={isPdfAvailable}
        isDownloading={isDownloading}
        onDownloadInvoice={handleDownloadInvoice}
        isCOAAvailable={isCOAAvailable}          // NEW
        onDownloadAllCoa={handleDownloadAllCoa}  // NEW
      />
      <DispatchTable
        lineItems={lineItems}
        invoiceNo={headerData?.invoiceNo}
        onDownloadCoa={handleDownloadCoa}
      />
    </div>
  );
};

export default DispatchDetails;